<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="確認"
  >
    <template v-slot:body="{ cancel, ok }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(ok)">
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container>
                <div class="font-weight-bold mb-3">
                  イントラネットFWを変更します。よろしいですか？
                </div>
                <div class="font-weight-bold mb-5 text-h6">
                  イントラネットFW契約 &ensp;&ensp;
                  <span v-if="intranetFwContractFlag"
                    >ON&ensp;&ensp;{{
                      intranetFwContract.intranetFwBandwidth.value
                    }}Mbps</span
                  ><span v-else>解約</span>
                </div>
                <!-- サブタイトル：アクセス回線 -->
                <div v-if="intranetFwContract.accessLineList.length > 0">
                  <div class="font-weight-bold text-h6">アクセス回線</div>
                  <v-row class="ml-3">
                    <v-col
                      class="mb-1"
                      cols="4"
                      v-for="(item, index) in intranetFwContract.accessLineList"
                      :key="index"
                    >
                      <div>
                        {{ item.enumber }}
                        <template v-if="item.isCheck">
                          &ensp;&ensp;
                          {{ item.bandwidth.value }}&ensp;Mbps
                        </template>
                        <template v-else> &ensp;&ensp;削除 </template>
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <!-- サブタイトル：リモートアクセスゲートウェイ -->
                <div v-if="intranetFwContract.remoteAccessGwList.length > 0">
                  <div class="font-weight-bold mt-3 text-h6">
                    リモートアクセスゲートウェイ
                  </div>
                  <v-table density="compact" class="tr-bordered">
                    <thead class="v-table-head">
                      <tr>
                        <th>メニュー</th>
                        <th>品目</th>
                        <th>E番号</th>
                        <th>Act/Sby</th>
                        <th>割当帯域</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template
                        v-for="(
                          remote, index
                        ) in intranetFwContract.remoteAccessGwList"
                        :key="index"
                      >
                        <tr>
                          <td rowspan="2">
                            {{ $filter.enumTo(remote.menu, "remoteAccessGw") }}
                          </td>
                          <td rowspan="2">
                            <span v-if="remote.contractType === 'BESTEFFORT'">{{
                              "-"
                            }}</span>
                            <span v-else
                              >{{ remote.contractBandwidth!.value }}Mbps
                            </span>
                          </td>
                          <td>{{ remote.enumberAct }}</td>
                          <td>Act</td>
                          <td v-if="remote.isCheck" rowspan="2">
                            {{ remote.bandwidthActSby.value }}&ensp;Mbps
                          </td>

                          <td v-else rowspan="2">削除</td>
                        </tr>
                        <tr>
                          <td class="no-border-top">{{ remote.enumberSby }}</td>
                          <td class="no-border-top">Sby</td>
                        </tr>
                      </template>
                    </tbody>
                  </v-table>
                </div>
                <!-- サブタイトル：プラットフォームアクセス -->
                <div v-if="intranetFwContract.pfgwList.length > 0">
                  <div class="font-weight-bold mt-3 text-h6">
                    プラットフォームゲートウェイ
                  </div>
                  <v-table density="compact" class="tr-bordered">
                    <thead class="v-table-head">
                      <tr>
                        <th>エリア</th>
                        <th>E番号</th>
                        <th>Act/Sby</th>
                        <th>割当帯域</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template
                        v-for="(plat, index) in intranetFwContract.pfgwList"
                        :key="index"
                      >
                        <tr>
                          <td rowspan="2">
                            {{ plat.office }}
                          </td>
                          <td>{{ plat.enumberAct }}</td>
                          <td>Act</td>
                          <td v-if="plat.isCheck">
                            {{ plat.bandwidthActSby.value }}&ensp;Mbps
                          </td>
                          <td v-else>削除</td>
                        </tr>
                        <tr>
                          <td class="no-border-top">{{ plat.enumberSby }}</td>
                          <td class="no-border-top">Sby</td>
                          <td v-if="plat.isCheck" class="no-border-top">
                            {{ plat.bandwidthActSby.value }}&ensp;Mbps
                          </td>
                          <td v-else class="no-border-top">削除</td>
                        </tr>
                      </template>
                    </tbody>
                  </v-table>
                </div>

                <v-row>
                  <!-- prettier-ignore  -->
                  <v-col>
                    <!-- eslint-disable-next-line vue/no-mutating-props -->
                    <validation-provider name="note" v-model="postItem.note"
                        label="オーダー備考"
                        :rules="{ max: { length: 200 } }"
                        v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-badge
                          item="オーダー備考"
                          :msg="
                      $filter.message('info_max_length', {
                        maxLength: '200',
                      })
                    "
                          :isRequired="false"
                      />
                      <app-form-input
                          v-bind="componentField"
                          :error-messages="errorMessage"
                          :field-meta="meta"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" variant="flat" color="primary">はい</v-btn>
                <v-btn variant="outlined" color="primary" @click="cancel"
                  >いいえ
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type {
  IntranetfwServiceMenu,
  IntranetfwServiceMenuPost,
} from "@/apis/IntranetfwServiceMenuApi";

export default defineComponent({
  name: "IntranetFwContractConfirm",
  props: {
    intranetFwContract: {
      type: Object as PropType<IntranetfwServiceMenu>,
      required: true,
    },
    intranetFwContractFlag: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    postItem: {
      type: Object as PropType<IntranetfwServiceMenuPost>,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.no-border-top {
  border-top: 0 !important;
}
</style>
